import axios from 'axios';

import { Id, PagedParams, PagedResponse, getData } from '@feature/utils';

import {
  ImpactFactor,
  ImpactFactorRank,
  Journal,
  JournalAisMetric,
  JournalAisRank,
  JournalRequest,
} from './JournalTypes';

export function getPaged(params: PagedParams) {
  return axios
    .get<PagedResponse<Journal>>('/journals/paged', {
      params,
    })
    .then(getData);
}

export function get(id: Id) {
  return axios.get<Journal>(`/journals/${id}`).then(getData);
}

export function edit(id: Id, request: JournalRequest) {
  return axios.put<Journal>(`/journals/${id}`, request).then(getData);
}

export function create(request: JournalRequest) {
  return axios.post<Journal>(`/journals`, request).then(getData);
}

export function deleteById(id: Id) {
  return axios.delete<unknown>(`/journals/${id}`).then(getData);
}

export function getJournalImpactFactorMetric(journalId: Id) {
  return axios.get<ImpactFactor[]>(`/journals/${journalId}/reputation/if/metrics`).then(getData);
}

export function getJournalImpactFactorRank(journalId: Id) {
  return axios.get<ImpactFactorRank[]>(`/journals/${journalId}/reputation/if/rank`).then(getData);
}

export function getJournalAisMetric(journalId: Id) {
  return axios.get<JournalAisMetric[]>(`/journals/${journalId}/reputation/ais/metrics`).then(getData);
}

export function getJournalAisRank(journalId: Id) {
  return axios.get<JournalAisRank[]>(`/journals/${journalId}/reputation/ais/rank`).then(getData);
}
